import React, { useState, useEffect } from 'react';
import './index.css';

import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Stats from './components/sections/Stats';
import Services from './components/sections/Services';
import Marquees from './components/sections/Marquees';
import Portfolio from './components/sections/Portfolio';
import Contact from './components/sections/Contact';
import CaseStudyModal from './components/ui/CaseStudyModal';


export default function App() {
  const [scrolled, setScrolled] = useState(false);
  const [statsVisible, setStatsVisible] = useState(false);
  const [activeCaseStudy, setActiveCaseStudy] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);

      const statsSection = document.getElementById('stats-section');
      if (statsSection) {
        const rect = statsSection.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100) {
          setStatsVisible(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen font-tech" style={{ backgroundColor: '#fbfbf5', color: '#1a1a1a' }}>
      <Navbar scrolled={scrolled} />
      <Hero />
      <About />
      <Stats statsVisible={statsVisible} />
      <Services />
      <Marquees />
      <Portfolio onOpenCase={setActiveCaseStudy} />
      <Contact />
      <Footer />
      <CaseStudyModal caseStudy={activeCaseStudy} onClose={() => setActiveCaseStudy(null)} />
    </div>
  );
}
